import script from "./VCustomAutocomplete.vue?vue&type=script&lang=js"
export * from "./VCustomAutocomplete.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__